import { FC, useContext, useState } from "react";
import "./License.css";
import { Context } from "../../..";
import { AppContext } from "../../../App";
import { isAxiosError } from "axios";
import ModalSuccess from "../../Shared/ModalWindows/ModalSuccess";
import ModalError from "../../Shared/ModalWindows/ModalError";
import LicenseUpload from "./LicenseUpload";

interface IActivateLicenseSettingProps {
    onClose?: () => void;
}

const ActivateLicenseSetting: FC<IActivateLicenseSettingProps> = ({
    onClose,
}) => {
    const { store } = useContext(Context);
    const [error, setError] = useState<string>();
    const [success, setSuccess] = useState<boolean>(false);

    if (success) {
        return <ModalSuccess onClose={onClose} headerText="Успешно"/>;
    }
    if (error) {
        return <ModalError bodyText={error} headerText="Ошибка" onClose={onClose}/>;
    }

    const handleActivate = async (file: File) => {
        try {
            await store.licenseService.activateLicense(file);
            setSuccess(true);
        } catch (err) {
            if (isAxiosError(err)) setError(err.response?.data.message);
        }
    };

    return (
        <LicenseUpload onActivate={handleActivate} showCloseElements={true} onClose={onClose}/>
    );
};

export default ActivateLicenseSetting;
